module.exports = __webpack_public_path__ + "media/images/application/subscribe/background-home-subscribe-297eaacd07a6c80fde68b21a6807df9a.svg";